import React, { useState } from 'react';
import IconButton from '@/ctComponents/IconButton';
import { EditEstimatedSaving } from './edit-estimated-savings';

export const SAVING_FIELDS = [
  {
    label: 'LMC Fee for Returning Empty from Yard to Terminal',
    name: 'savingLmcFee',
    unit: '$',
    shortLabel: 'LMC Fee',
  },
  {
    label: 'Container Moving Rate',
    name: 'savingContainerMovingRate',
    unit: '$/Mile',
    shortUnit: '$',
    required: true,
  },
  {
    label: 'Prepull Rate',
    name: 'savingPrePullRate',
    unit: '$',
  },
  {
    label: 'Chassis Fee',
    name: 'savingChassisFee',
    unit: '$/day',
    shortUnit: '$',
    required: true,
  },
  {
    label: 'Chassis Split Fee',
    name: 'savingChassisSplitFee',
    unit: '$',
  },
  {
    label: 'Storage Fee',
    name: 'savingStorageFee',
    unit: '$',
  },
  {
    label: 'Fuel Surge Charge',
    name: 'savingFuelSurgeCharge',
    unit: '$',
  },
  {
    label: 'Congestion Fee',
    name: 'savingCongestionFee',
    unit: '$',
  },
  {
    label: 'Detention Fee',
    name: 'savingDetentionFee',
    unit: '$',
  },
  {
    label: 'Scale Fee',
    name: 'savingScaleFee',
    unit: '$',
  },
  {
    label: 'Flat Fee',
    name: 'savingFlatFee',
    unit: '$',
  },
];

const DataRow = ({ label, value, isLast = false }) => {
  return (
    <div
      className={`flex justify-between ${
        !isLast
          ? 'border-t-0 border-l-0 border-r-0 border-b border-solid pb-3'
          : ''
      }`}>
      <span className="font-bold text-sm flex items-center">{label}</span>
      <span className="text-sm text-secondary-text">{value || 'N/A'}</span>
    </div>
  );
};

export const EstimatedSaving = ({
  savingData,
  onDataUpdate,
  updateSavingData,
}) => {
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <>
      <div className="border border-solid pb-4 flex-1 rounded-md">
        <div className="flex justify-between items-center px-4">
          <h2 className="text-lg font-bold ">Estimated Saving</h2>
          <IconButton
            onClick={() => {
              setOpenEditModal(true);
            }}
            style={{ fontWeight: 400, height: 40, width: 78 }}
            icon={'pen'}
            text={'Edit'}
            color={'#131617'}
            size={'big'}
          />
        </div>
        <hr
          className="mb-4 mt-0 border-t border-solid"
          style={{
            width: 'calc(100% - 32px)',
          }}
        />

        <div className="space-y-3 max-h-550 overflow-y-auto px-4">
          {SAVING_FIELDS.map((field, index) => (
            <DataRow
              key={index}
              label={field.label}
              value={
                <>
                  {savingData?.[field.name] || ''}
                  {field.unit}
                </>
              }
              isLast={index === SAVING_FIELDS.length - 1}
            />
          ))}
        </div>
      </div>
      <EditEstimatedSaving
        show={openEditModal}
        setShow={setOpenEditModal}
        data={savingData}
        onSave={onDataUpdate}
        updateSavingData={updateSavingData}
      />
    </>
  );
};
